'use strict';

var _ = require('underscore');
var ACTION_TYPES = require('./actionTypes');
var storeDataUtils = require('./storeDataUtils');
///////////
//
// ACTION CREATORS
//
///////////
var actionCreators = {

	setFromBackbone: function setFromBackbone(attrs) {
		return {
			type: ACTION_TYPES.BACKBONE_MODEL_SET,
			attrs: attrs
		};
	},

	setModelId: function setModelId(id) {
		return {
			type: ACTION_TYPES.SET_MODEL_ID,
			id: id
		};
	},

	///////////
	// HOTSPOTS
	///////////
	addHotspot: function addHotspot(hotspotData) {
		return function addHotspotThunk(dispatch, getState) {
			hotspotData.hotspotId = _.isUndefined(hotspotData.hotspotId) ? storeDataUtils.getNewHotspotId(getState()) : hotspotData.hotspotId;

			dispatch({
				type: ACTION_TYPES.ADD_HOTSPOT,
				hotspotData: hotspotData
			});

			return hotspotData.hotspotId;
		};
	},

	updateHotspot: function updateHotspot(hotspotData) {
		return function updateHotspotThunk(dispatch) {

			if(_.isUndefined(hotspotData.hotspotId)) {
				throw new Error('Must have hotspotId');
			}

			dispatch({
				type: ACTION_TYPES.UPDATE_HOTSPOT,
				hotspotData: hotspotData
			});

		};
	},

	removeHotspot: function removeHotspot(hotspotId) {
		return {
			type: ACTION_TYPES.REMOVE_HOTSPOT,
			hotspotId: hotspotId
		};
	},

	selectHotspot: function selectHotspot(hotspotId) {
		return {
			type: ACTION_TYPES.SELECT_HOTSPOT,
			hotspotId: hotspotId
		};
	},

	addAndSelectHotspot: function addAndSelectHotspot(hotspotData) {
		return function addAndSelectThunk(dispatch) {

			var hotspotId = dispatch(actionCreators.addHotspot(hotspotData));
			return dispatch(actionCreators.selectHotspot(hotspotId));
		};
	},

	changeBoxMode: function changeBoxMode(boxMode) {
		return {
			type: ACTION_TYPES.CHANGE_BOX_MODE,
			boxMode: boxMode
		};
	},

	///////////
	// INPUT MODE
	///////////
	togglePreventInput: function togglePreventInput() {
		return {
			type: ACTION_TYPES.TOGGLE_PREVENT_INPUT
		};
	},

	changePreventInput: function changePreventInput(preventInput) {
		return {
			type: ACTION_TYPES.CHANGE_PREVENT_INPUT,
			preventInput: preventInput
		};
	},

	///////////
	// MODEL INFO
	///////////
	changeModelId: function changeModelId(modelId) {
		return {
			type: ACTION_TYPES.CHANGE_MODEL_ID,
			modelId: modelId
		};
	},

	changeModelUrl: function changeModelUrl(modelUrl) {
		return {
			type: ACTION_TYPES.CHANGE_MODEL_URL,
			modelUrl: modelUrl
		};
	},

	changeModelRotation: function changeModelRotation(modelRotation) {
		return {
			type: ACTION_TYPES.CHANGE_MODEL_ROTATION,
			modelRotation: modelRotation
		};
	},

	changeResolution: function changeResolution(resolution) {
		return {
			type: ACTION_TYPES.CHANGE_RESOLUTION,
			resolution: resolution
		};
	},


	///////////
	// VIEW
	///////////
	setViewMode: function setViewMode(viewMode) {
		return {
			type: ACTION_TYPES.SET_VIEW_MODE,
			viewMode: viewMode
		};
	},

	setIsPreviewing: function setIsPreviewing(isPreviewing) {
		return isPreviewing ? actionCreators.showShapeJsView() : actionCreators.showX3DomView();
	},

	toggleIsPreviewing: function toggleIsPreviewing() {
		return {
			type: ACTION_TYPES.TOGGLE_IS_PREVIEWING
		};
	},

	showShapeJsView: function showShapeJsView() {
		return {
			type: ACTION_TYPES.SHOW_SHAPE_JS_VIEW
		};
	},

	showX3DomView: function showX3DomView() {
		return {
			type: ACTION_TYPES.SHOW_X3DOM_VIEW
		};
	},

	waitForViewer: function waitForViewer() {
		return {
			type: ACTION_TYPES.WAIT_FOR_VIEWER
		};
	},

	stopWaitingForViewer: function stopWaitingForViewer() {
		return {
			type: ACTION_TYPES.STOP_WAITING_FOR_VIEWER
		};
	},

	setFormActions: function setFormActions(formActions) {
		return {
			type: ACTION_TYPES.SET_FORM_ACTIONS,
			formActions: formActions
		};
	}

};

module.exports = actionCreators;
